import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { Field, Label, Select, ValidationMessage } from '@digdir/designsystemet-react';
import { FC } from 'react';

import { ByggType } from '../../../../../../components/registering/utils/registerEnums';
import { OmBoligenFormData } from '../types';

interface OptionProps {
  type: ByggType;
}
const ByggkategoriOption: FC<OptionProps> = ({ type }) => {
  const { t } = useTranslation();
  return <Select.Option value={type}>{t(`buildingCategory.${type}`)}</Select.Option>;
};

export const ByggtypeSelect = () => {
  const { t } = useTranslation();
  const { register, watch, formState } = useFormContext<OmBoligenFormData>();
  const registrationId = watch('registreringId');

  const error = formState.errors.bygginfo?.byggtype?.message;

  return (
    <Field aria-disabled={!!registrationId}>
      <Label>{t('register.bygningsdetaljer.boligtype.label')}</Label>
      <Select
        disabled={!!registrationId}
        aria-invalid={!!error}
        {...register('bygginfo.byggtype', { required: t('register.bygningsdetaljer.boligtype.error') })}
        defaultValue=""
        width="full"
      >
        <Select.Option disabled value=""></Select.Option>
        <ByggkategoriOption type={ByggType.Enebolig} />
        <ByggkategoriOption type={ByggType.EneboligMedUtleiedel} />
        <ByggkategoriOption type={ByggType.TomannsboligHorisontalDelt} />
        <ByggkategoriOption type={ByggType.TomannsboligVertikalDelt} />
        <ByggkategoriOption type={ByggType.Firemannsbolig} />
        <ByggkategoriOption type={ByggType.KjedetEnebolig} />
        <ByggkategoriOption type={ByggType.Rekkehus} />
        <ByggkategoriOption type={ByggType.Fritidsbolig} />
        <ByggkategoriOption type={ByggType.AnnetSmahus} />
        <ByggkategoriOption type={ByggType.Leilighet} />
        <ByggkategoriOption type={ByggType.AnnenBolig} />
      </Select>
      {error && <ValidationMessage data-color="danger">{error}</ValidationMessage>}
    </Field>
  );
};
